export default {
  buttons: {
    add: 'Adicionar',
  },
  AddOn: {
    label: 'Extra',
    title: 'Obtenha a sua aplicação móvel',
    subscribed: 'Subscrito',
    cta: 'Obtenha a sua aplicação móvel',
    price_per_month: '{{price}} / mês',
    tax_included: 'IVA incluído',
    apple_developer_note: 'Requer uma conta Apple Developer (99 $/ano, paga à Apple) na entidade legal do restaurante.',
    features: {
      stores: 'Disponível na App Store e no Google Play',
      push: 'Notificações push para os seus clientes',
      loyalty: 'Pontos de fidelidade e recompensas',
      commission: 'Pedidos diretos com 0% de comissão',
    },
  },
};
